import ko from "knockout";
import register from "flow/knockout/register";
import reflectCustomProperties from "./reflectCustomProperties";

declare global {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface KnockoutExtenders {
        enforceMin(target: KnockoutObservable<number>, enforceMin: number): KnockoutObservable<number>;
    }
}

register.registerKnockoutExtension("enforceMin", (target: KnockoutObservable<number>, minValue: number) => {
    //create a writeable computed observable to intercept writes to our observable
    const interceptor = ko
        .computed({
            read: target, //always return the original observables value
            write(newValue: number) {
                const current = target();
                const minVal = ko.unwrap(minValue);

                const valueToWrite = newValue >= minVal ? newValue : minVal;

                //only write if it changed
                if (valueToWrite !== current) {
                    target(valueToWrite);
                } else {
                    //if the value is the same, but a different value was written, force a notification for the current field
                    if (newValue !== current) {
                        target.notifySubscribers(valueToWrite);
                    }
                }
            }
        })
        .extend({
            notify: "always"
        });

    reflectCustomProperties(target, interceptor);

    //initialize with current value to make sure it is rounded appropriately
    interceptor(target());

    //return the new computed observable
    return interceptor;
});
